<div class="flex flex-col">
     <h2 class="center-text">Venue Health</h2>
     <!-- export csv button -->
     <div class="flex w-100 justify-start">
            <button (click)="exportToCSV()" class="plain-button ml-10">Download CSV</button>
    </div>
    <!-- table -->
    <table class="reports-table">
      <thead>
        <tr>
          <th>Venue</th>
          <th>Client</th>
          <th>Issues</th>
          <th>Details</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let report of venueHealthReports; let i = index; else noRecord">
          <td>{{ report.venue_name }}</td>
          <td>{{ report.client_name }}</td>
          <td>
            <ul class="issues-list">
              <li *ngFor="let issue of report.issues">{{ issue.type == 'attendance_drop' ? 'Attendance Drop' : issue.type == 'game_cancellations' ? 'Game Cancellations' : 'Post Arrival Cancellations' }}</li>
            </ul>
          </td>
          <td>
            <ul class="issues-list">
              <li *ngFor="let issue of report.issues">
                <div *ngIf="issue.type === 'attendance_drop'">
                  <div><strong>Recent Avg:</strong> {{ issue.details.recent_avg }}%</div>
                  <div><strong>Compare Avg:</strong> {{ issue.details.compare_avg }}%</div>
                  <div><strong>Target Drop:</strong> {{ issue.details.target_value }}%</div>
                </div>
                <div *ngIf="issue.type === 'game_cancellations' || issue.type === 'post_arrival_cancellations'">
                  <ul class="issues-list">
                    <li *ngFor="let date of issue.details.dates">{{ date | date:'mediumDate' }}</li>
                  </ul>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
</div>

<ng-template #noRecord>
    <tr>
        <td colspan="4" class="center-text">No Record Found</td>
    </tr>
</ng-template>
